import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";

export default class OnboardingStepScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     * @param {MediatorManager} mediatorManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;

        /** @type {string} */
        this._stepId = this.getCustomData().stepId;

        this._onboardingStepScreenMediator = null;
    }

    initialize() {
        super.initialize();

        this._target.onboardingStepContainer.removeAllChildren();
        this._createOnboardingStep();
    }

    destroy() {
        super.destroy();

        this._onboardingStepScreenMediator.destroy();
        this._onboardingStepScreenMediator = null;
    }

    _createOnboardingStep() {
        const onboardingStepSkin = new lib.MainAssets[`OnboardingStep_${this._stepId}`]();
        this._target.onboardingStepContainer.addChild(onboardingStepSkin);

        this._onboardingStepScreenMediator = this._mediatorManager.createMediator(onboardingStepSkin, SkinKeyRegistry.GENERIC_ONBOARDING_STEP);
        this._onboardingStepScreenMediator.setStepId(this._stepId);
    }
}